import { apiCall, ApiResult } from './core';

export const finopsAPI = {
  getProjectCosts: async (clientId: string | null = null, timePeriod = 'current_month', userRole: string | null = null): Promise<ApiResult> => {
    try {
      const params = new URLSearchParams();
      // For AWS users, client_id is required
      if (userRole === 'aws') {
        if (!clientId) {
          return { success: true, data: [] };
        }
        params.set('client_id', clientId);
      } else if (clientId) {
        params.set('client_id', clientId);
      }
      if (timePeriod) params.set('time_period', timePeriod);

      const queryString = params.toString();
      const data = await apiCall(`/finops/project-costs${queryString ? '?' + queryString : ''}`);
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  }
};

export const financeAPI = {
  getCostAnalytics: async (_userRole: string | null, _tenantId: string | null, _projectId: string | null, startDate: string | null = null, endDate: string | null = null): Promise<ApiResult> => {
    try {
      // Build query string with date parameters if provided
      const params = new URLSearchParams();
      if (startDate) {
        params.append('start_date', startDate);
      }
      if (endDate) {
        params.append('end_date', endDate);
      }

      const queryString = params.toString();
      const url = queryString ? `/finance/analytics?${queryString}` : '/finance/analytics';

      const data = await apiCall(url);
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      console.error('Error fetching cost analytics:', error);
      return { success: false, error: err.message };
    }
  },

  getBudgetAlerts: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/finance/budget-alerts');
      return { success: true, data: data.alerts || [] };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  }
};
